module.exports = __webpack_public_path__ + "img/hospitality-section1.60dc037d.svg";